import { CircularLoader } from '@modules/common/components/CircularLoader';
import { FeedbackListStoreProvider } from '@modules/feedback/store/useFeedbackListStore';
import { ExpandedFeedbackContent } from '@modules/feedbackV2/expanded/components/ExpandedFeedbackContent';
import { Stack } from '@mui/material';
import { useState } from 'react';
import { FeedbackLabel } from 'v2/core/entities/feedback';
import { IsLoading } from 'v2/core/repository/edge-server/types';
import { useGetFeedback } from 'v2/core/services/records';

interface ArtefactCitationFeedbackDrawerContentProps {
  recordID: string | null;
}

export const ArtefactCitationFeedbackDrawerContent = ({
  recordID,
}: ArtefactCitationFeedbackDrawerContentProps) => {
  const [selectedPredictionLabels, setSelectedPredictionLabels] = useState<
    FeedbackLabel[]
  >([]);

  const { feedback, status, error } = useGetFeedback(recordID ?? '');

  if (error || !recordID) {
    return (
      <Stack
        height="100vh"
        textAlign="center"
        alignItems="center"
        justifyContent="center"
        spacing={3}
        mt={-8}
      >
        Failed to fetch feedback record. Please try again later.
      </Stack>
    );
  }

  if (IsLoading(status)) {
    return (
      <CircularLoader
        sx={{
          mt: 10,
        }}
      />
    );
  }

  return (
    <FeedbackListStoreProvider>
      <ExpandedFeedbackContent
        feedback={feedback}
        isLoading={false}
        selectedPredictionLabels={selectedPredictionLabels}
        setSelectedPredictionLabels={setSelectedPredictionLabels}
      />
    </FeedbackListStoreProvider>
  );
};
